module.exports = __webpack_public_path__ + "img/grid.3024dafd.svg";